import { memo, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { Box, Flex, IconButton, Menu, MenuButton, MenuList, MenuItem, useColorModeValue, Portal } from '@chakra-ui/react';
import { formatTweetFromPost } from "utils/linkedinUtils";
import Thread from 'components/tweets/masonry/thread';
import { LuMoreVertical, LuEye, LuTrash, LuEdit } from 'react-icons/lu';
import { ItemProps, ItemPresentationProps } from './types';

const ItemPresentation = memo(({
  post,
  listeners,
  account,
  isComposerActive,
  onPreview,
  onDelete,
  onEdit
}: ItemPresentationProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  let threadTweets = post?.type == "tweet" ? post.text.split("\n\n\n") : [post.text];
  return (
    <Box
      bg={useColorModeValue("white", "#1E1E1E")}
      borderWidth="1px"
      borderColor={isComposerActive ? useColorModeValue("primary.lightMode.200", "primary.darkMode.200") : useColorModeValue("border.lightMode.light", "border.darkMode.light")}
      boxShadow={isComposerActive ? `0px 0px 0px 3px var(--chakra-colors-primary-lightMode-100)` : "none"}
      borderRadius="md"
      position="relative"
      _hover={{
        "& > .action-buttons": {
          opacity: 1,
          pointerEvents: "auto"
        }
      }}
      overflow="hidden"
      cursor="grab"
      {...listeners}
    >
      {/* <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        h="full"
        cursor="grab"
        zIndex={2}
        {...listeners}
      /> */}

      <Flex
        className="action-buttons"
        position="absolute"
        top={4}
        right={4}
        opacity={isMenuOpen ? 1 : 0}
        pointerEvents={isMenuOpen ? "auto" : "none"}
        transition="opacity 0.2s"
        zIndex={3}
        gap={2}
      >
        {/* <Button
          aria-label="Edit"
          variant="primary"
          size="sm"
        >
          Add to queue
        </Button> */}
        <IconButton
          variant="secondary"
          size="sm"
          aria-label="Edit"
          onClick={onEdit}
          icon={<LuEdit />}
        >
          <LuEdit />
        </IconButton>

        <Menu onOpen={() => setIsMenuOpen(true)} onClose={() => setIsMenuOpen(false)} placement='bottom-end'>
          <MenuButton
            as={IconButton}
            icon={<LuMoreVertical />}
            variant="secondary"
            size="sm"
            aria-label="Options"
          />
          <Portal>
            <MenuList
            >
              <MenuItem icon={<LuEye />} onClick={onPreview}>Preview</MenuItem>
              <MenuItem icon={<LuTrash />} onClick={onDelete} color="red.500">Delete</MenuItem>
            </MenuList>
          </Portal>
        </Menu>
      </Flex>

      <Thread
        threadTweets={threadTweets}
        disableNbChar={true}
        tweet={formatTweetFromPost({ post, user: account })}
        showOutline={false}
        image={post.image || "/emptyProfile.png"}
        name={post.name}
        expandableSeeMore={true}
      />
    </Box>
  )
});

export const Item = memo(({ id, post, account, isComposerActive, onPreview, onDelete, onEdit }: ItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
  } = useSortable({
    id: id,
    data: {
      type: 'item',
    },
  });
  if (!post) return null;
  return (
    <div data-id={id} ref={setNodeRef} {...attributes}>
      <ItemPresentation
        post={post}
        listeners={listeners}
        account={account}
        isComposerActive={isComposerActive}
        onPreview={onPreview}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    </div>
  );
}); 